import TableWrap from "../Common/Table/Table";
import React from "react";
import { amountFormat } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import { useHistory } from "react-router-dom";
import moment from "moment";

const AdvReport = (props) => {
  const history = useHistory()
  const columns = [
    {
      title: "Report ID",
      dataIndex: "report_number",
      key: "report_number",
    },
    {
      title: "From Date",
      dataIndex: "from_date",
      key: "from_date",
      render: (text) => text ? moment(text).format("DD-MM-YYYY, HH:mm:ss") : "-",
    },
    {
      title: "To Date",
      dataIndex: "to_date",
      key: "to_date",
      render: (text) => text ? moment(text).format("DD-MM-YYYY, HH:mm:ss") : "-",
    },
    {
      title: "Recorded By",
      dataIndex: "submitted_by",
      key: "submitted_by",
    },

    {
      title: "Amount",
      dataIndex: "total_amount",
      key: "total_amount",
      render: (text) => <div><BaseCurrency /> {amountFormat(text)}</div>,
    },
    {
      title: "Actions",
      dataIndex: "status",
      key: "status",
      render: (text) => <div className={`status status_${text}`}>{text.replace(/_/g, ' ')}</div>,
    },
  ];
  return (
    <div className="expenses-table">
      <TableWrap pagination={false} columns={columns} data={props.from === "report" ? props.repData : [props.repData]} handleRowClick={(evt, record) => {
        if (record) {
          history.push({
            pathname: `/report-details/${record.id}`,
            state: { reportData: record },
          });
        }
      }} />
    </div>
  );
};

export default AdvReport;
